import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';
import { useClassroomsWithoutProvider } from 'queries/classrooms/useClassrooms';

export function useClassroomsCopyEvents({
  schoolId,
  schoolyearId,
}: {
  schoolId?: string;
  schoolyearId?: string;
}) {
  const { guestMode } = useUser();
  const { data } = useClassroomsWithoutProvider({
    schoolId: guestMode?.enabled ? undefined : schoolId,
    schoolyearId: guestMode?.enabled ? undefined : schoolyearId,
  });
  const classroomsFromContext = useClassrooms();
  return guestMode?.enabled ? classroomsFromContext : data;
}
